module.exports = __webpack_public_path__ + "img/RX-Arcos-1-zoom.b86dd5ae.png";